import React, { useState } from 'react';

import { PageHeader } from '~/presentation/components/header';
import { IconUser } from '~/presentation/base/icons';

import { Perfil } from '~/presentation/components/formPerfilData';
import { DeleteAccount } from '~/presentation/components/deleteAccount';
import { ProfessionalData } from '~/presentation/components/professionalData';
import { ChangePassword } from '~/presentation/components/changePassword';
import { Menu } from '~/presentation/components/menu';
import { Container, Body, LockScroll } from './StyleProfile';
import { PerfilNavigator } from './PerfilNavigator';
import { translator } from '~/presentation/components/i18n';
import { ScaleProfessionalConfig } from '~/presentation/components/scaleProfessionalConfig';
import { useLocation } from 'react-router-dom';

const PerfilManager: React.FC = (): JSX.Element => {
  const query = new URLSearchParams(useLocation().search);
  const scale = query.get('scale');

  const [navigation, setNavigation] = useState<number>(scale ? 5 : 1);

  const RenderSubPages: React.FC = () => {
    switch (navigation) {
      case 1:
        return <Perfil />;
      case 2:
        return <ChangePassword />;
      case 3:
        return <ProfessionalData />;
      case 4:
        return <DeleteAccount />;
      case 5:
        return <ScaleProfessionalConfig />;
      default:
        return <div />;
    }
  };
  return (
    <Container>
      <LockScroll>
        <Menu />
        <PageHeader
          title={translator('Perfil do usuário')}
          icon={IconUser}
          scale={!!scale}
        />
      </LockScroll>
      <Body>
        <PerfilNavigator nav={setNavigation} active={navigation} />
        <div id="container">
          <RenderSubPages />
        </div>
      </Body>
    </Container>
  );
};

export default PerfilManager;
